// extracted by mini-css-extract-plugin
export default {"logout":"Logout_logout__0yj8S","logoutBtn":"Logout_logoutBtn__WIETb"};